import { render, staticRenderFns } from "./OtherProduct.vue?vue&type=template&id=5bbb1da6&"
import script from "./OtherProduct.vue?vue&type=script&lang=js&"
export * from "./OtherProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports